import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import axios from 'axios'
import { push } from 'react-router-redux'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import TextField from 'material-ui/TextField'
import Divider from 'material-ui/Divider'
import IconButton from 'material-ui/IconButton'
import MoreVertIcon from 'material-ui-icons/Save'

class Messages extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dataIncoming: [],
      dataOutgoing: [],
      loadedIncoming: false,
      loadedOutgoing: false,
      showSaveOutbound: false,
      outgoingSaveShow: false,
      incomingSaveShow: false,
      inboundvalue: '',
      outboundvalue: ''
    }
  }

  async getIncomingMessages() {
    let currentComponent = this

    let data = this.props.data
    let access_id = data['access id']

    await axios
      .get(
        'https://api.dsnapis.com/customer/' +
          this.props.customer_number +
          '/pw/teSt1/candidate/' +
          access_id +
          '/commtype/1/db/2/read'
      )
      .then(function(response) {
        if (Array.isArray(response.data)) {
          currentComponent.setState(
            {
              dataIncoming: response.data,
              loadedIncoming: true
            },
            function() {
              currentComponent.getOutgoingMessages()
            }
          )
          //alert(JSON.stringify(response.data))
        } else {
          currentComponent.setState(
            {
              loadedIncoming: true
            },
            function() {
              currentComponent.getOutgoingMessages()
            }
          )
        }
      })
  }

  async getOutgoingMessages() {
    let currentComponent = this

    let data = this.props.data
    let access_id = data['access id']

    let url = `https://api.dsnapis.com/customer/${
      this.props.customer_number
    }/pw/teSt1/candidate/${access_id}/commtype/2/db/2/read`
    await axios.get(url).then(function(responder) {
      if (Array.isArray(responder.data)) {
        //alert(JSON.stringify(responder.data))
        currentComponent.setState(
          {
            dataOutgoing: responder.data,
            loadedOutgoing: true
          },
          function() {}
        )
      } else {
        currentComponent.setState({
          loadedOutgoing: true
        })
      }
    })
  }

  componentDidMount() {
    //this.getIncomingMessages();
    let currentComponent = this
    setTimeout(function() {
      if (currentComponent.props.customer_number != null) {
        currentComponent.getIncomingMessages()
      } else {
        alert("Communication Diary couldn't be loaded.")
      }
    }, 1500)
  }

  onSaveInbound() {
    let new_object = {
      message: this.state.inboundvalue
    }

    let new_inbound_messages = this.state.dataIncoming

    if (new_inbound_messages.length == 3) {
      new_inbound_messages[0] = new_inbound_messages[1]
      new_inbound_messages[1] = new_inbound_messages[2]
      new_inbound_messages[2] = new_object
    } else {
      new_inbound_messages.push(new_object)
    }

    let message_own = this.state.inboundvalue

    this.setState({
      dataIncoming: new_inbound_messages,
      inboundvalue: '',
      incomingSaveShow: false
    })

    let data = this.props.data
    let access_id = data['access id']
    let url = `https://api.dsnapis.com/customer/${
      this.props.customer_number
    }/pw/teSt1/candidate/${access_id}/commtype/1/message/${message_own}/db/2/write`
    axios.get(url)
  }

  onSaveOutbound() {
    let new_object = {
      message: this.state.outboundvalue
    }

    let new_outbound_messages = this.state.dataOutgoing

    if (new_outbound_messages.length == 3) {
      new_outbound_messages[0] = new_outbound_messages[1]
      new_outbound_messages[1] = new_outbound_messages[2]
      new_outbound_messages[2] = new_object
    } else {
      new_outbound_messages.push(new_object)
    }

    let message_own = this.state.outboundvalue

    this.setState({
      dataOutgoing: new_outbound_messages,
      outboundvalue: '',
      outgoingSaveShow: false
    })

    let data = this.props.data
    let access_id = data['access id']
    let url = `https://api.dsnapis.com/customer/${
      this.props.customer_number
    }/pw/teSt1/candidate/${access_id}/commtype/2/message/${message_own}/db/2/write`
    //alert(url);
    axios.get(url)
  }

  handleInboundChange = inbound => event => {
    this.setState(
      {
        inboundvalue: event.target.value
      },
      function() {
        if (this.state.inboundvalue.length > 0) {
          this.setState({
            incomingSaveShow: true
          })
        } else {
          this.setState({
            incomingSaveShow: false
          })
        }
      }
    )
  }

  handleOutboundChange = outbound => event => {
    this.setState(
      {
        outboundvalue: event.target.value
      },
      function() {
        if (this.state.outboundvalue.length > 0) {
          this.setState({
            outgoingSaveShow: true
          })
        } else {
          this.setState({
            outgoingSaveShow: false
          })
        }
      }
    )
  }

  onSeeAllInbound(data) {
    let access_id = data['access id']
    this.props.changeRoute('/console/all_communication/inbound/' + access_id)
  }

  onSeeAllOutbound(data) {
    let access_id = data['access id']
    this.props.changeRoute('/console/all_communication/outbound/' + access_id)
  }

  render() {
    const { classes, theme, location, data } = this.props

    return (
      <div>
        <br />
        <br />
        <Typography type="headline" color="secondary" className={classes.root2}>
          Communications Diary
        </Typography>
        <br />
        <div>
          <Typography
            type="subheading"
            color="secondary"
            className={classes.root}
          >
            Inbound
          </Typography>
          <Button
            onClick={() => this.onSeeAllInbound(data)}
            className={classes.seeall}
            color="primary"
          >
            SEE ALL
          </Button>
        </div>
        <br />
        {this.state.dataIncoming.map(function(profile, index) {
          return (
            <div>
              <Typography color="secondary" className={classes.maxSpace}>
                {index + 1}: {profile.message}
              </Typography>
            </div>
          )
        })}
        {!this.state.loadedIncoming && (
          <div>
            <Typography color="secondary">Loading...</Typography>
          </div>
        )}
        {this.state.loadedIncoming && (
          <div>
            <TextField
              id="inbound"
              label="New inbound message"
              className={classes.textField}
              onChange={this.handleInboundChange('inbound')}
              value={this.state.inboundvalue}
              margin="normal"
            />
            {this.state.incomingSaveShow && (
              <IconButton
                aria-label="Save Inbound"
                aria-haspopup="true"
                className={classes.menuIcon}
                onClick={() => this.onSaveInbound()}
              >
                <MoreVertIcon />
              </IconButton>
            )}
          </div>
        )}
        <br />
        <br />
        <br />
        <Divider />
        <br />
        <div>
          <Typography
            type="subheading"
            color="secondary"
            className={classes.root}
          >
            Outbound
          </Typography>
          <Button
            onClick={() => this.onSeeAllOutbound(data)}
            className={classes.seeall}
            color="primary"
          >
            SEE ALL
          </Button>
        </div>
        {this.state.dataOutgoing.map(function(profile, index) {
          return (
            <div>
              <Typography color="secondary" className={classes.maxSpace}>
                {index + 1}: {profile.message}
              </Typography>
            </div>
          )
        })}
        {!this.state.loadedOutgoing && (
          <div>
            <Typography color="secondary">Loading...</Typography>
          </div>
        )}
        {this.state.loadedOutgoing && (
          <div>
            <TextField
              id="outbound"
              label="New outbound message"
              className={classes.textField}
              onChange={this.handleOutboundChange('outbound')}
              value={this.state.outboundvalue}
              margin="normal"
            />
            {this.state.outgoingSaveShow && (
              <IconButton
                aria-label="Save Outbound"
                aria-haspopup="true"
                className={classes.menuIcon}
                onClick={() => this.onSaveOutbound()}
              >
                <MoreVertIcon />
              </IconButton>
            )}
          </div>
        )}
        <br />
        <br />
        {this.state.showSaveOutbound && (
          <Button disableRipple raised color="primary">
            Save Message
          </Button>
        )}
        <br />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    changeRoute: url => dispatch(push(url))
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, mapDispatchToProps)(Messages)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/User/scenes/Core/components/Messages/index.js